export const DEMO_WORKSPACE_NAME = 'Pied Piper Inc.'
export const DEMO_PROJECT_NAME = 'Frontend'
